export const SIGNEDURL_BACKEND_ENDPOINT = 'https://d1cdbbnuzj7idz.cloudfront.net/prod/signurl'
export const CFSTATIC_BACKEND_ENDPOINT = 'https://d28nynx0ys6755.cloudfront.net/api'
export const DIRECTSTATIC_BACKEND_ENDPOINT = 'https://caching-backend.pgjaiganesh.space/api'
export const WATERMARK_IMAGE_ENDPOINT = "https://d296dlyyh7mn7k.cloudfront.net/"
export const CACHING_BACKEND_ENDPOINT = "https://d1qpr2b61meppc.cloudfront.net/"
export const NO_ATTEMPTS = [
    {
      "label": 25,
      "value": 25
    },
    {
        "label": 50,
        "value": 50
      },
      {
        "label": 75,
        "value": 75
      },

]
export const CACHE_NO_ATTEMPTS = 15
export const NO_ATTEMPTS_LARGEFILES = [
    {
      "label": 25,
      "value": 25
    },
    {
        "label": 50,
        "value": 50
      }
]
export const PERFORMANCE_ENTRIES = 300
export const PRICING_BACKEND_ENDPOINT = 'https://d1d6kxn3oboaih.cloudfront.net'
export const CMCD_STREAM_ENDPOINT = 'https://d3u5zq5hamcctt.cloudfront.net/video/hls/buck_bunny/Big_BuckBunny_5mins.m3u8'
export const INSPECT_REQUEST_ENDPOINT = "https://integrationpointsstack-us-east-1-cf.demos.edge.aws.dev/"
export const FEEDBACK_ENDPOINT = 'https://d1d6kxn3oboaih.cloudfront.net'
export const WAF_DASHBOARD_ENDPOINT = "https://search-osdfw-opensearch-domain-evjwzsrpaygh7jpb3tb53rvzgi.us-east-1.es.amazonaws.com/_dashboards/app/dashboards#/view/main-dashboard?_g=(filters%3A!()%2CrefreshInterval%3A(pause%3A!t%2Cvalue%3A10000)%2Ctime%3A(from%3Anow-1d%2Cto%3Anow))"
export const CDN_FINDER_ENDPOINT = "https://d2u8wb9u3zuxnh.cloudfront.net/"
export const WAFCOMMON_ENDPOINT = "https://d3az5q5lpqfw4v.cloudfront.net/"
export const WAFATP_ENDPOINT = "https://dvmr2mn9818sv.cloudfront.net"
export const MULTI_CDN_ENDPOINT = "https://g-286a68fcac.grafana-workspace.us-east-1.amazonaws.com/d/1CuRJMKVz/cdn-comparison-performance-metrics?orgId=1"
export const CF_RUM_ENDPOINT = "https://g-286a68fcac.grafana-workspace.us-east-1.amazonaws.com/d/FL-7Nz5Vk2/observability-website-performance?orgId=1"
export const SIMPLE_CHANNEL_ENDPOINT = "https://dl0aiy1r4giyd.cloudfront.net/"
export const DEMOPORTAL_USAGE_ENDPOINT = "https://g-e700501c45.grafana-workspace.us-east-1.amazonaws.com/d/Lkpvpv24z/demo-portal-usage-stats?orgId=1"
export const CONTENT_DISCOVERY_ENDPOINT = "https://l231lapeg5.execute-api.us-east-1.amazonaws.com/"

// Edge Functions demos
export const EDGE_FUNCTIONS_CF_ENDPOINT = "https://d1zxgpsjn6v3he.cloudfront.net"
export const EDGE_FUNCTIONS_MANAGER_ENDPOINT = "https://ueyiticso5.execute-api.us-east-1.amazonaws.com/manage"
export const EDGE_FUNCTIONS_METRICS_ENDPOINT = "https://ueyiticso5.execute-api.us-east-1.amazonaws.com/metrics"

// Networking Architecture Builder (backend/networking-architecture-builder)
export const NETWORKING_ARCHITECTURE_BUILDER_ENDPOINT = ""
// Edge Experience Center (backend/edge-experience-center)
export const EDGE_EXPERIENCE_CENTER_ENDPOINT = ""
